import { getS3Url, notifyCompleteUploadOnS3, uploadOnS3 } from '@lib/api_ts/massiveUploadDocumentsApi';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { UploadChoiceType } from './UploadDataButton';

export const useMassiveDocumentsUpload = () => {
	const queryClient = useQueryClient();
	const [progress, setProgress] = useState(0);
	const resetProgress = () => setProgress(0);
	const { projectId } = useParams<{ projectId: string }>();
	const location = useLocation();
	const activeKey = location.hash?.replace('#', '') || 'contracts';
	const mutation = useMutation({
		mutationFn: async (params: { file: File; uploadType: UploadChoiceType }) => {
			const s3Url = await getS3Url();

			await uploadOnS3(s3Url.uploadUrl, params.file, (percent) => {
				setProgress(percent);
			});

			await notifyCompleteUploadOnS3(`/v0/projects/${projectId}/${activeKey}`, s3Url.s3Path, s3Url.fileName);

			return { success: true };
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['batches', projectId] });
			queryClient.invalidateQueries({ queryKey: ['entities', projectId] });
			queryClient.invalidateQueries({ queryKey: ['staging-entities', projectId] });
			queryClient.invalidateQueries({ queryKey: ['staging-checklists', projectId] });
			queryClient.invalidateQueries({ queryKey: ['staging-docs', projectId] });
			resetProgress();
		},
		onError: resetProgress,
	});

	return { mutation, progress };
};
